
import { Component, Prop } from "vue-property-decorator";
import BaseFormControl from "../../helpers/BaseFormControl";
import BaseControlWrapper from "./BaseControlWrapper.vue";

@Component({
  name: "BaseTextInputFormCpf",
  components: {
    BaseControlWrapper,
  },
})
export default class BaseTextInputFormCpf extends BaseFormControl {
  @Prop isSearch: boolean | undefined;

  created(): void {
    super.created();
  }
}
